import { useTimeAgoFormatter } from "../../hooks/useTimeAgoFormatter";
import { UserInteraction } from "../../services/userInteractions";
import { UserAvatar } from "../UserAvatar";
import TimeAgo from 'react-timeago'
import { LabelMedium, ParagraphSmall, ParagraphXSmall } from "baseui/typography";
import { useStyletron } from "baseui";
import { HorizontalStackPanel } from "../../components/Layout/StackPanel";
import { FormattedMessage } from "react-intl";
import { useGetObjectByIdQuery } from "../../services/objects";
import { HierarchyObjectNavigation } from "../../components/HierarchyNavigation";
import { LoadingView } from "../../components";
import { Badge, HIERARCHY, COLOR } from "baseui/badge";

const UserInteractionItem = (props: any) => {
    const [css, theme] = useStyletron();
    const { formatter } = useTimeAgoFormatter();
    return (
        <>
            <HorizontalStackPanel  $width={'100%'}>
                <UserAvatar size={'scale700'} userId={props.userId}></UserAvatar>
                <TypeSelector {...props}></TypeSelector>
            </HorizontalStackPanel>
            <HorizontalStackPanel  $width={'100%'} className={css({ marginTop: '10px' })}>

                <ParagraphXSmall margin={0} color={theme.colors.contentSecondary}>
                    <TimeAgo date={props.timeStamp} formatter={formatter}></TimeAgo>
                </ParagraphXSmall>
            </HorizontalStackPanel>
        </>
    )
}

export default UserInteractionItem;


const TypeSelector = (props: any): any => {
    switch (props.type) {
        case 'Users.IntegrationEvents.DigitalTwinChanged':
            return <DigitalTwinChangedItem {...props}></DigitalTwinChangedItem>
        case 'Users.IntegrationEvents.DigitalTwinCreated':
            return <DigitalCreatedItem {...props}></DigitalCreatedItem>
        case 'Users.IntegrationEvents.DigitalTwinRelationCreated':
            return <DigitalRelationCreatedItem {...props}></DigitalRelationCreatedItem>
        case 'Users.IntegrationEvents.DigitalTwinRelationDeleted':
            return <DigitalRelationDeletedItem {...props}></DigitalRelationDeletedItem>
        default:
            return <>UNKNOWN: {props.type}</>
    }
}


const DigitalTwinChangedItem = (props: UserInteraction) => {
    return (
        <ParagraphSmall margin={0}>
            <FormattedMessage id='UserInteractions.changed' defaultMessage='changed {property} to: {value}'
                values={
                    {
                        property: <b>{props.data.propertyName}</b>,
                        value: <b><code>{props.data.value}</code></b>
                    }
                } />
        </ParagraphSmall>
    )
}

const DigitalCreatedItem = (props: UserInteraction) => {
    const [css, theme] = useStyletron();
    return (
        <LabelMedium ><FormattedMessage id='UserInteractions.hasCreatedApp' defaultMessage={'has created App'}></FormattedMessage></LabelMedium>
    )
}

const DigitalRelationCreatedItem = (props: any) => {
    const [css, theme] = useStyletron();
    return (
        <>
            <>
                <FormattedMessage id='UserInteractions.relationAdd' defaultMessage='has add relation to {obj} type {value}'
                    values={
                        {
                            obj: <ObjectLink objectId={props.data.toTwinId} resourceGroupId={props.resourceGroupId}></ObjectLink>,
                            value: <b><code>{props.data.type}</code></b>
                        }
                    } />
            </>
        </>
    )
}

const DigitalRelationDeletedItem = (props: any) => {
    const [css, theme] = useStyletron();
    return (
        <>
            <>
                <FormattedMessage id='UserInteractions.relationDeleted' defaultMessage='has deleted relation to {obj} type {value}'
                    values={
                        {
                            obj: <ObjectLink objectId={props.data.toTwinId} resourceGroupId={props.resourceGroupId}></ObjectLink>,
                            value: <b><code>{props.data.type}</code></b>
                        }
                    } />
            </>
        </>
    )
}

const ObjectLink = (props: { resourceGroupId: string, objectId: string }) => {

    const { data, isSuccess, isLoading, error } = useGetObjectByIdQuery({ id: props.objectId, resourceGroupId: props.resourceGroupId });

    const err: any = error;
    console.log(err);
    return (<LoadingView rows={1} isLoading={isLoading} isSucess={isSuccess} >
        {data && <HierarchyObjectNavigation objectId={props.objectId} resourceGroupId={props.resourceGroupId} current={data.name} currentDescription={data.description} showDescription={false} currentAsLink={true} ></HierarchyObjectNavigation>}
        {err?.originalStatus === 404 &&
            <Badge
                content={<FormattedMessage id="UserInteractions.objNotExists" defaultMessage={"Object doesn't exist any more"}></FormattedMessage>}
                hierarchy={HIERARCHY.secondary}
                color={COLOR.warning}
            >
               
            </Badge>}
    </LoadingView>)

}